import React, { type PropsWithChildren } from 'react';

import { theme } from '@garnish/constants';

import { VStack } from '../../../../../Stack';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarMenuList = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <VStack dividerColor={theme.colors.LIGHT} gap={0} hasDivider>
      {children}
    </VStack>
  );
};
